<script setup lang="ts">

</script>

<template>
  <!-- Manifesto / Metodo PureJoule -->
  <section id="metodo" class="border-t border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-950">
    <UContainer class="py-14 md:py-20">
      <div class="grid gap-10 lg:grid-cols-2 lg:items-center">
        <!-- Copy -->
        <div class="max-w-2xl">
          <UBadge
            variant="subtle"
            class="border border-slate-200 bg-slate-50 text-slate-700 dark:border-slate-800 dark:bg-slate-900 dark:text-slate-200"
          >
            Metodo PureJoule · Every joule matters
          </UBadge>

          <h2 class="mt-5 text-2xl font-semibold text-slate-900 dark:text-white md:text-3xl">
            Allenarsi meglio, non di più.
          </h2>

          <p class="mt-3 text-slate-600 dark:text-slate-300">
            PureJoule è pensato per <strong>atleti amatori</strong>: tempo limitato, recupero fondamentale, vita reale.
            Per questo ogni allenamento ha uno scopo e ogni decisione è guidata da metodo, dati e ascolto del corpo.
          </p>

          <div
            class="mt-6 rounded-3xl border border-slate-200 bg-slate-50 p-6 dark:border-slate-800 dark:bg-slate-900/50"
          >
            <p class="text-sm font-semibold text-slate-900 dark:text-white">
              Il principio
            </p>
            <p class="mt-2 text-sm leading-relaxed text-slate-600 dark:text-slate-300">
              I dati guidano, il corpo decide. La performance nasce da progressioni sostenibili, recupero rispettato
              e costanza nel lungo periodo — non dal “sempre al massimo”.
            </p>
          </div>

          <div class="mt-7 flex flex-wrap items-center gap-3">
            <UButton color="primary" size="lg" class="shadow-sm">
              Prenota una call
            </UButton>
            <UButton
              variant="outline"
              size="lg"
              class="border-slate-200 text-slate-900 hover:bg-slate-50 dark:border-slate-800 dark:text-white dark:hover:bg-slate-900"
            >
              Scopri i pacchetti
            </UButton>
          </div>
        </div>

        <!-- Pillars -->
        <div class="grid gap-4 sm:grid-cols-2">
          <UCard class="rounded-3xl border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-950">
            <template #header>
              <p class="text-sm font-semibold text-slate-900 dark:text-white">
                Efficienza energetica
              </p>
              <p class="text-xs text-slate-500 dark:text-slate-400">
                più resa, meno sprechi
              </p>
            </template>
            <p class="text-sm leading-relaxed text-slate-600 dark:text-slate-300">
              Miglioriamo la capacità di “fare di più con la stessa energia”, costruendo base aerobica e qualità mirata.
            </p>
          </UCard>

          <UCard class="rounded-3xl border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-950">
            <template #header>
              <p class="text-sm font-semibold text-slate-900 dark:text-white">
                Progressione sostenibile
              </p>
              <p class="text-xs text-slate-500 dark:text-slate-400">
                carico coerente con la vita
              </p>
            </template>
            <p class="text-sm leading-relaxed text-slate-600 dark:text-slate-300">
              Aumenti graduali, settimane sensate e recupero vero: così migliori senza saltare per aria.
            </p>
          </UCard>

          <UCard class="rounded-3xl border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-950">
            <template #header>
              <p class="text-sm font-semibold text-slate-900 dark:text-white">
                Consapevolezza
              </p>
              <p class="text-xs text-slate-500 dark:text-slate-400">
                capire → eseguire → migliorare
              </p>
            </template>
            <p class="text-sm leading-relaxed text-slate-600 dark:text-slate-300">
              Sai sempre cosa stai facendo e perché: autonomia, segnali del corpo e decisioni migliori.
            </p>
          </UCard>

          <UCard class="rounded-3xl border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-950">
            <template #header>
              <p class="text-sm font-semibold text-slate-900 dark:text-white">
                Performance nel tempo
              </p>
              <p class="text-xs text-slate-500 dark:text-slate-400">
                niente scorciatoie
              </p>
            </template>
            <p class="text-sm leading-relaxed text-slate-600 dark:text-slate-300">
              Costanza e lungo periodo battono l’entusiasmo del momento. Si costruisce, non si improvvisa.
            </p>
          </UCard>
        </div>
      </div>
    </UContainer>
  </section>
</template>

<style scoped>

</style>
